import axios from "axios";
import { bun_server } from "./baseUrl";
import { geoServerBaseUrl } from "./baseUrl";

// const KEY_MAPBOX = `pk.eyJ1IjoibWFwaWQiLCJhIjoiY2pqNWtnaW10MGNnMjNrcWg5MHQwY21nNiJ9.voWwMqU73TCDDua3mGCb8g`;

//GET

//get_location_list
// export const get_location_list_old = (params) => async (dispatch) => {
//   try {
//     params = JSON.stringify(params);
//     const endpoint_api = `https://api.mapbox.com/geocoding/v5/mapbox.places/${params}.json?country=id&proximity=ip&access_token=${KEY_MAPBOX}`;
//     const res = await axios.get(endpoint_api);
//     dispatch({
//       type: "get_location_list",
//       payload: res?.data?.features || [],
//     });
//     dispatch({
//       type: "set_value_properties",
//       payload: {
//         key: "location_result_list",
//         value: res?.data?.features || [],
//       },
//     });
//   } catch (e) {}
// };

export const get_location_list =
  ({ search_input, viewbox }) =>
  async (dispatch) => {
    try {
      const endpoint_api = `https://nominatim.mapid.io/search?format=jsonv2&addressdetails=1&limit=10&polygon_geojson=1&viewbox=${viewbox}&q=${search_input}`;
      const res = await axios.get(endpoint_api);
      dispatch({
        type: "set_value_properties",
        payload: {
          key: "location_result_list",
          value: res?.data || [],
        },
      });
    } catch (e) {}
  };

//filter_tanggal
export const filter_tanggal = ({ tanggal, mode }) => {
  return {
    type: "filter_tanggal",
    payload: { tanggal, mode },
  };
};

// filter tanggal new
/* 
  body = {
    start : "",
    end : ""
  }
*/
// export const filter_tanggal_new = (body) => {
//   return {
//     type: "filter_tanggal_new",
//     payload: body,
//   };
// };

export const filter_tanggal_new = (body) => async (dispatch) => {
  dispatch({
    type: "filter_tanggal_new",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
};

export const clear_tanggal = () => (dispatch) => {
  dispatch({
    type: "clear_tanggal",
  });
  dispatch({
    type: "status_action",
  });
};

//set_item_on_layer
export const set_item_on_layer = (body) => (dispatch) => {
  dispatch({
    type: "set_item_on_layer",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
};

//set_data_array
export const set_data_array = (body) => {
  return {
    type: "set_data_array",
    payload: body,
  };
};

//reset_fields
export const reset_fields = (body) => {
  return {
    type: "reset_fields",
    payload: body,
  };
};

//grid_cilicis
export const grid_cilicis = (params) => async (dispatch) => {
  const { feature_key, lat, long, genangan_cm } = params;
  try {
    dispatch(setLoading("grid_cilicis"));
    const res = await axios.get(
      geoServerBaseUrl +
        `/grid_cilicis?lat=${lat}&long=${long}&genangan_cm=${genangan_cm}`,
    );
    let features = res?.data?.features ? res?.data?.features : [];
    features = features.map((f) => {
      return { ...f, feature_key };
    });
    dispatch({
      type: "grid_cilicis",
      payload: features,
    });
    //handle ketika success masukkan status success ke dalam array feature_list_genangan
    dispatch({
      type: "push_key_genangan_success",
      payload: feature_key,
    });

    const body = {
      feature_key,
      geojson: res.data,
    };
    dispatch({
      type: "push_luas_genangan_list",
      payload: body,
    });
    dispatch(clearLoading());
  } catch (e) {
    //handle ketika error masukkan status error ke dalam array feature_list_genangan
    dispatch({
      type: "push_key_genangan_error",
      payload: feature_key,
    });
    dispatch(clearLoading());
  }
};

//setLoading
export const setLoading = (itemLoading) => {
  return {
    type: "SET_LOADING_PROCESS_LAYER",
    payload: itemLoading,
  };
};

//clearLoading
export const clearLoading = () => {
  return {
    type: "CLEAR_LOADING_LAYER",
  };
};

//undo_filter_isi_layer
export const undo_filter_isi_layer = (body) => async (dispatch) => {
  /*
  body = {
  geo_layer_id,
  field_key,
  value,
  }
  */
  dispatch({
    type: "undo_filter_isi_layer",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
  dispatch({
    type: "fly_action",
  });
};

//
/**
 *filter_isi_layer --> Melakukan filter isi layer dengan parameter key-value dari sebuah kolom
 * @body  {
  geo_layer_id,
  field_key,
  value,
  start_date: tanggal,
  end_date: tanggal
  }
 * @returns
 */
export const filter_isi_layer = (body) => async (dispatch) => {
  dispatch({
    type: "filter_isi_layer",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
  dispatch({
    type: "fly_action",
  });
};

//reset_filter
export const reset_filter = (body) => async (dispatch) => {
  /*
  body = {
  geo_layer_id,
  }
  */
  dispatch({
    type: "reset_filter",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
  dispatch({
    type: "fly_action",
  });
};

//set_feature
export const set_feature = (body) => async (dispatch) => {
  dispatch({
    type: "set_feature",
    payload: body,
  });
};

//view_layer
/*
  body = {
  geo_layer_id,
  value,
  }
  */
export const view_layer = (body) => async (dispatch) => {
  dispatch({
    type: "view_layer",
    payload: body,
  });
  dispatch({
    type: "fly_action",
  });
  dispatch({
    type: "status_action",
  });
};

export const view_heatmap = (body) => async (dispatch) => {
  /*
  body = {
  geo_layer_id,
  value,
  }
  */
  dispatch({
    type: "view_heatmap",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
};

//set_layer_id
export const set_layer_id = (layer_id) => async (dispatch) => {
  try {
    dispatch({
      type: "set_layer_id",
      payload: layer_id,
    });
    dispatch(clearLoading());
  } catch (error) {
    dispatch(clearLoading());
  }
};

// feature_key_array
export const set_feature_key_array = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "array_key",
      payload: body,
    });
    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "simple_map_action",
    });
    dispatch(clearLoading());
  } catch (error) {
    dispatch(clearLoading());
  }
};

// Filter Nested Table
export const setNestedTableFilter = (payload) => ({
  type: "SET_NESTED_TABLE_FILTER",
  payload,
});

export const get_property_app = (bbox) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_property_app",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
      params: {
        bbox: bbox,
      },
    };
    const res = await axios.get(
      bun_server + `/sini_v2/get_property_app`,
      config,
    );
    const data = res?.data || [];
    dispatch({
      type: "set_value_properties",
      payload: {
        key: "features_property_app",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_property_app",
    });
  } catch (error) {}
};

export const get_activities_app =
  (bbox, limit = 100) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "set_loading_action",
        payload: "get_activities_app",
      });

      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      const body = {
        bbox: bbox,
        limit: limit,
      };

      const res = await axios.post(
        "https://alphaserver.mapid.io/mobile/v2/communities/activities/public",
        body,
        config,
      );

      const features_activities_app = res?.data?.data?.activities || [];

      /*
      {

  "title": "Warung Nasi Ibu Imas",
  "description": "Warung Nasi Sunda paling legendaris di Bandung",
  "geometry": {
    "type": "Point",
    "coordinates": [
      107.60718298426542,
      -6.927556623759298
    ]
  },
  "medias": [
    "https://mapid-app-chat.s3.ap-southeast-3.amazonaws.com/69e6f1b9492d90fe21a282ff/437f3844-f1cb-4109-ac92-24ae81a9fa71_YiHolpXRcW.png",
    "https://mapid-app-chat.s3.ap-southeast-3.amazonaws.com/69e6f1b9492d90fe21a282ff/a5c9241e-2439-484a-82fa-6076d99a9166_1776776017646.jpg",
    "https://mapid-app-chat.s3.ap-southeast-3.amazonaws.com/69e6f1b9492d90fe21a282ff/d1c68612-0783-4712-adaf-9d69c9501489_1776776017687.jpg",
    "https://mapid-app-chat.s3.ap-southeast-3.amazonaws.com/69e6f1b9492d90fe21a282ff/a8f11eaa-466f-4009-8019-6c1960d23aba_1776776017707.jpg"
  ],
  "user_name": "bagusid",
  "user_full_name": "Bagus Darmawan [Apps]",
  "user_profile_picture": {
    "name": "general_image/bagusid/1765542596183_image_picker_665B40DE-9AD5-4D95-BCEF-0BC65224AAF9-5242-00001A20218F08CA.jpg",
    "url": "https://mapidstorage.s3.ap-southeast-1.amazonaws.com/general_image/bagusid/1765542596183_image_picker_665B40DE-9AD5-4D95-BCEF-0BC65224AAF9-5242-00001A20218F08CA.jpg",
    "name_compressed": "general_image/bagusid/1765542596183_image_picker_665B40DE-9AD5-4D95-BCEF-0BC65224AAF9-5242-00001A20218F08CA.jpg",
    "url_compressed": "https://mapidstorage.s3.ap-southeast-1.amazonaws.com/general_image/bagusid/1765542596183_image_picker_665B40DE-9AD5-4D95-BCEF-0BC65224AAF9-5242-00001A20218F08CA.jpg"
  },
}
      */

      dispatch({
        type: "set_value_properties",
        payload: {
          key: "features_activities_app",
          value: features_activities_app,
        },
      });

      dispatch({
        type: "clear_loading_action",
        payload: "get_activities_app",
      });
    } catch (error) {
      dispatch({
        type: "clear_loading_action",
        payload: "get_activities_app",
      });
    }
  };
